import { render, staticRenderFns } from "./FmTabPane.vue?vue&type=template&id=50c4ce78&"
import script from "./FmTabPane.vue?vue&type=script&lang=js&"
export * from "./FmTabPane.vue?vue&type=script&lang=js&"
import style0 from "./FmTabPane.vue?vue&type=style&index=0&id=50c4ce78&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports